export default {
  frec: {
    enabled: true,
    defaultExpandedMenu: false,
    enableFixByteSizeButton: false,
  },
  ftao: {
    enabled: true,
    enableDashboardExport: false,
    enableSuggestions: false,
    enablePowerbi: false,
  },
  digitalTwin: {
    enabled: false,
    enableMonitoring: false,
  },
  ui: {
    enableAdvancedShortcuts: true,
    enableChangelistTableColumnsResizing: false,
    enableChangelistTableGoToTop: false,
    enableChangelistPaginationOnTop: false,
    enableChangelistTableClickOnRowSelect: false,
    enableTour: false,
    enableAssistant: false,
    defaultOpenSidebar: true,
    enableDeviceFamily: true,
    gravatarEmail: '',
    defaultExpandedMainMenu: false,
    defaultExpandedRightMenu: false,
    reportsGridColumns: 12,
    reportsGridRowHeight: 28,
    reportsItemHeaderHeight: 40,
    reportsItemMargin: 10,
    reportsEnableExport: true,
    enableStickyNavbar: false,
    enableStickyFooter: false,
  },
  charts: {
    highchartsEnableExport: false,
    highchartsExportWidth: 1320,
    highchartsExportHeight: 400,
    colorAxisStopsLight: [
      { perc: 0, color: '#fff' },
      { perc: 0.00000000001, color: '#02BB49' },
      { perc: 0.08, color: '#22D01C' },
      { perc: 0.16, color: '#74D11D' },
      { perc: 0.24, color: '#B2D116' },
      { perc: 0.32, color: '#E0E70A' },
      { perc: 0.4, color: '#F0E905' },
      { perc: 0.48, color: '#FFEA00' },
      { perc: 0.56, color: '#FFCD00' },
      { perc: 0.64, color: '#FFB000' },
      { perc: 0.72, color: '#FF9300' },
      { perc: 0.8, color: '#FF7500' },
      { perc: 0.88, color: '#FF3B00' },
      { perc: 1, color: '#FF0000' },
    ],
    colorAxisStopsDark: [
      { perc: 0, color: '#000' },
      { perc: 0.00000000001, color: '#02BB49' },
      { perc: 0.08, color: '#22D01C' },
      { perc: 0.16, color: '#74D11D' },
      { perc: 0.24, color: '#B2D116' },
      { perc: 0.32, color: '#E0E70A' },
      { perc: 0.4, color: '#F0E905' },
      { perc: 0.48, color: '#FFEA00' },
      { perc: 0.56, color: '#FFCD00' },
      { perc: 0.64, color: '#FFB000' },
      { perc: 0.72, color: '#FF9300' },
      { perc: 0.8, color: '#FF7500' },
      { perc: 0.88, color: '#FF3B00' },
      { perc: 1, color: '#FF0000' },
    ],
    palette: [
      '#c10206',
      '#dfe2db',
      '#fac213',
      '#ff7f3f',
      '#774360',
      '#a64b2a',
      '#3f4e4f',
      '#b09b71',
      '#ffc4c4',
      '#90aacb',
      '#9fc088',
      '#ec9cd3',
      '#35858b',
      '#a68dad',
      '#b68973',
    ],
  },
  maps: {
    defaultTiles: 'esriworldimagery',
    defaultLayer: 'stamentonerhybrid',
    polylineHeatmapStops: [
      { perc: 0, color: '#fff' },
      { perc: 0.00000000001, color: '#02BB49' },
      { perc: 0.08, color: '#22D01C' },
      { perc: 0.16, color: '#74D11D' },
      { perc: 0.24, color: '#B2D116' },
      { perc: 0.32, color: '#E0E70A' },
      { perc: 0.4, color: '#F0E905' },
      { perc: 0.48, color: '#FFEA00' },
      { perc: 0.56, color: '#FFCD00' },
      { perc: 0.64, color: '#FFB000' },
      { perc: 0.72, color: '#FF9300' },
      { perc: 0.8, color: '#FF7500' },
      { perc: 0.88, color: '#FF3B00' },
      { perc: 1, color: '#FF0000' },
    ],
  },
  data: {
    vTableSignalVariabilityLimit: 20,
    dataAnalyticsMaxSignalValuesInterval: 60 * 60 * 24,
    modelDashboardMaxSignalValuesInterval: 60 * 60 * 12,
    modelDashboardLiveDataSignalInterval: 60 * 10,
    masterChartSamples: 1000,
    masterChartMaxChunkDuration: 60 * 60 * 24 * 30,
    exportRowsLimit: 10000,
  },
  reports: {
    signalPlotChartsSamples: 10000,
    gpsTrackingSamples: 10000,
    enableLocalReports: false,
  },
  logger: {
    level: process.env.REACT_APP_LOGGER_LEVEL,
  },
  debounceTime: 500,
  enableSaveFilters: false,
  enableSavePagination: false,
  enableReadOnlyDetails: false,
}
